var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "splash-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,64 C0,16 16,0 64,0 C112,0 128,16 128,64 C128,112 112,128 64,128 C16,128 0,112 0,64",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-23.1409231%",
    y1: "109.104231%",
    x2: "89.3592308%",
    y2: "28.5274615%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1C4B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C31CB",
    offset: "98.2893%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-7.65120695%",
    y1: "84.8281949%",
    x2: "103.100704%",
    y2: "9.351179%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.38,
    offset: "7.1783%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "27.5198%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "55.2083%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "26.106608%",
    y1: "97.91843%",
    x2: "86.9535834%",
    y2: "56.4083104%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.38,
    offset: "7.1783%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "27.5198%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "55.2083%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-7.65112638%",
    y1: "60.262017%",
    x2: "53.2292625%",
    y2: "18.7062952%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.38,
    offset: "7.1783%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "27.5198%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "55.2083%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "splash-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(27.569231, 28.061538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8584615,0.246153846 C9.06909538,0.246153846 0.120172308,9.57134769 0.120172308,35.8823385 L11.8891323,35.8823385 C11.8891323,30.8878769 12.0395323,26.8696615 12.7163569,23.6406154 L29.3233231,34.3552 C29.4237538,34.4177231 29.5236923,34.4802462 29.6241231,34.5427692 C32.5065846,36.2077538 34.5624615,37.0338462 37.8461538,37.0338462 C41.1421538,37.0338462 43.1852308,36.2077538 46.0681846,34.5427692 C46.1681231,34.4802462 46.2685538,34.4177231 46.3689846,34.3552 L62.8878769,23.4402462 C63.6524308,27.0203077 63.8153846,31.6637538 63.8153846,37.6344615 C63.8153846,54.7579077 61.4966154,59.7518769 37.9337846,59.7646769 L37.9337846,71.5180308 C66.6604308,71.5057231 75.5845055,62.6308923 75.5845055,37.6344615 C75.5968,9.68398769 67.0114462,0.246153846 37.8584615,0.246153846 Z M41.3051077,24.4416 C39.2123077,25.5808 36.4672,25.5931077 34.3744,24.4416 L19.7852554,14.3278277 C23.6583385,12.6505354 29.3735385,11.9996554 37.8584615,11.9996554 C46.3438769,11.9996554 51.8833231,12.5253415 55.744,14.1275569 L41.3051077,24.4416 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9937231,54.8455385 L22.9937231,48.9747692 C22.9937231,45.7329231 20.3617969,43.1044923 17.1156185,43.1044923 L5.99842462,43.1044923 C2.75224615,43.1044923 0.120221538,45.7329231 0.120221538,48.9747692 C0.120221538,52.2166154 2.75224615,54.8455385 5.99842462,54.8455385 L22.9937231,54.8455385 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8236308,59.8897231 L13.71904,59.8897231 C10.4728615,59.8897231 7.84083692,62.5181538 7.84083692,65.7604923 C7.84083692,69.0023385 10.4728615,71.6307692 13.71904,71.6307692 L30.7017846,71.6307692 L30.7017846,65.7604923 C30.7017846,62.5181538 28.0699077,59.8897231 24.8236308,59.8897231 Z",
    id: "Path",
    fill: "url(#linearGradient-6)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd6de32332a70abdf39dc4597cfd3092.svg";
export { ForwardRef as ReactComponent };